import { makeStyles } from '@material-ui/styles'
import { Theme } from 'styling/theme'

export default makeStyles((theme: Theme) => ({
    progressBar: {
        backgroundColor: '#44464b',
        width: '100%',
        height: '4px',
    },
    bar: {
        backgroundColor: theme.colors.brand.pink,
        backgroundImage: `linear-gradient(to right, ${theme.colors.brand.yellow} , ${theme.colors.brand.pink})`,
        height: '100%',
        width: '100%',
        transformOrigin: 'left',
    },
}))
